import api from "../API";
function wxconfigUrl() {
  let url = location.href;
  return location.href.split("#")[0];
}
const wxConfig = async function(title, desc, link, img) {
  let signdata = {};
  let url = location.href.split("#")[0];
  console.log(title, desc, link, img);
  api
    .newGetWxSign({ url })
    .then(result => {
      console.log("reuslt---", result);
      if (result.code == 200) {
        signdata = result.data;
      }
      // debugger;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: signdata.appId, // 必填，公众号的唯一标识
        timestamp: signdata.timestamp, // 必填，生成签名的时间戳
        nonceStr: signdata.noncestr, // 必填，生成签名的随机串
        signature: signdata.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function(e) {
        console.log("wxsdk ready", e);
        //配置成功之后回调
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function(e) {
            console.log("设置分享成功---", "updateAppMessageShareData");
          }
        });
        wx.updateTimelineShareData({
          title: title, // 分享标题
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function() {
            console.log("微信JS SDK配置成功！", "updateTimelineShareData");
          }
        });
      });
      // updateWxShareData(title, desc, link, img);

      wx.error(function(res) {
        console.log("微信JS SDK配置错误！", res);
      });
    })
    .catch(err => {
      console.log(err);
    });
};
// const updateWxShareData = function(title, desc, link, img) {
//   console.log(title, desc, link, img);

// };

export { wxConfig };



// WEBPACK FOOTER //
// ./src/js/utils/wechat.js